import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FirstTimeAcknowledgement = ({ isOpen, onCancel, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="w-full max-w-md bg-card border border-border rounded-lg shadow-lg overflow-hidden">
        <div className="p-6 md:p-8">
          <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-primary/10 rounded-full mx-auto mb-4 md:mb-6">
            <Icon name="Shield" size={32} color="var(--color-primary)" strokeWidth={2} />
          </div>

          <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-3 text-center">
            Post anonymously
          </h3>

          <p className="text-sm md:text-base text-muted-foreground leading-relaxed mb-6 text-center">
            By posting, you agree that content revealing identities may be removed to protect privacy.
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              variant="outline"
              onClick={onCancel}
              fullWidth
            >
              Cancel
            </Button>
            <Button
              variant="default"
              onClick={onConfirm}
              fullWidth
            >
              I understand, post
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirstTimeAcknowledgement;